import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { Query } from 'react-apollo'
import assign from 'lodash/assign'
import get from 'lodash/get'

// import QuestionLeft from './common/QuestionLeft'
import TimeAgo from './common/TimeAgo'
import { Loader } from '../containers/Loader'
import { COMMENTS_PER_PAGE } from '../config'
import QUESTION_QUERY from '../graphql/QuestionDetailQuery.graphql'
import {getPageTitle, submissionsClosed} from '../utils'

import Comments from './Comments'
import AddComment from "./Board/AddComment";
import AskQuestion from "./Board";

class QuestionDetail extends Component {
  render() {
    const questionId = this.props.match.params.id;
    // const boardId = this.props.match.params.boardId

    return (
      <Query
        query={QUESTION_QUERY}
        variables={{
          // boardId: `Board:${boardId}`,
          id: `Question:${questionId}`,
          first: COMMENTS_PER_PAGE,
        }}
      >
        {({ loading, data, fetchMore, refetch }) => {
          if (loading) {
            return <Loader />
          }
          const pageInfo = get(data, 'getQuestion.comments.pageInfo', {})
          const {
            created,
            title,
            description,
            // upvotes,
            // downvotes,
            creatorDisplayName,
            board,
            // isUpvotedByMe,
            // image,

          } = data.getQuestion
          return (
            <DocumentTitle title={getPageTitle(title)}>
              <div className="pt-4">
                <div className="container">
                    <div className="card">
                        <div className="card-header pb-4 jelly-card-header">
                            <div className="row">
                                <div className="px-3"><h4>{title}</h4></div>
                            </div>
                            <div className="row">
                                <div className="px-3">{description}</div>
                            </div>
                            <div className="row">
                                {/*<div className="px-3 pt-3"><a href={`/board/${board.uuid}`}>{board.topic}</a></div>*/}
                                <div className="px-3 py-2"><a href={`/board/${board.uuid}`}>{board.topic}</a></div>
                            </div>
                            <div className="row">
                                <div className="px-3 pb-3 text-muted">
                                    Posted by {creatorDisplayName} <TimeAgo date={created} />
                                </div>
                            </div>
                            {/*{!isArchived && !submissionsClosed(data.getBoard) && (<AddComment board={data.getBoard} onCloseRefreshHandler={() => refetch()} />)}*/}
                            <div className="row">
                                <div className="col-sm-6 col-md-3 col-lg-2 pb-2">
                                    {!submissionsClosed(data.getQuestion.board) && (<AddComment buttonType='button' board={data.getQuestion.board} question={data.getQuestion} onCloseRefreshHandler={() => refetch()} />)}
                                </div>
                            </div>
                        </div>
                        <div className="card-body">

                            {/*<div className="d-flex flex-row align-items-center justify-content-between">*/}
                            <div>
                                <div className="pt-2"><h4>Comments</h4></div>
                            </div>

                            <Comments
                            edges={get(data, 'getQuestion.comments.edges', [])}
                            pageInfo={pageInfo}
                            onLoadMore={() =>
                                fetchMore({
                                    variables: {
                                        id: `Question:${questionId}`,
                                        after: pageInfo.endCursor,
                                        first: COMMENTS_PER_PAGE,
                                    },
                                    updateQuery: (prev, { fetchMoreResult }) => {
                                        if (!fetchMoreResult) return prev
                                        // Merge the edges together, but keep the new pageInfo
                                        return assign({}, prev, {
                                            getQuestion: {
                                                ...prev.getQuestion,
                                                comments: {
                                                    ...prev.getQuestion.comments,
                                                    pageInfo: fetchMoreResult.getQuestion.comments.pageInfo,
                                                    edges: [
                                                        ...prev.getQuestion.comments.edges,
                                                        ...fetchMoreResult.getQuestion.comments.edges,
                                                    ],
                                                },
                                            },
                                        })
                                    },
                                })
                            }
                        />

                        </div>
                    </div>
                </div>
              </div>
            </DocumentTitle>
          )
        }}
      </Query>
    )
  }
}

export default QuestionDetail



// WEBPACK FOOTER //
// ./src/components/QuestionDetail.jsx